import { useSelector } from 'react-redux';
import { combineReducers } from 'redux';

import scanReducer from '@features/Scan/redux/scanSlice';
import favouriteSlice from '@features/favourites/redux/favouriteSlice';
import myProjectSlice from '@features/project-management-tools/redux/myProjectSlice';
import myProjectDetailsSlice from '@features/project-management-tools/redux/myProjectDetailsSlice';
import MaterialRequisitionReducer from '@features/material-requisition/redux/reducer/MaterialRequisitionReducer';

import checkboxFilterReducer from '@store/checkboxFilter/reducer';
import materialReducer from '@store/material/reducer';
import commonFiltersReducer from '@store/common/reducer';
import orderReducer from '@store/orders/reducers';
import salesContractReducer from '@store/salesContract/reducers';
import MarketReducer from '@store/reducers/MarketReducer';
import BrandReducer from '@store/reducers/BrandReducer';
import CategoryReducer from '@store/reducers/CategoryReducer';
import SeasonReducer from '@store/reducers/SeasonReducer';
import FabricReducer from '@store/reducers/FabricReducer';
import MaterialReducer from '@store/reducers/MaterialReducer';
import { CollectionReducer, RoleBasedCollection } from '@store/reducers/CollectionReducer';
import {
	DependentFilterListReducer,
	FilterFieldReducer,
	FilterResponseReducer,
	MultiLevelFilterReducer,
	SlectedCheckBoxFieldReducer,
	ToggleBlockSuggestionFilterReducer
} from '@store/reducers/FilterReducer';
import UserReducer from '@store/reducers/userReducer';
import commercialDashboardReducer from '@store/dashboard/commercial-dashboard/reducers';
import designReducer from '@store/design/reducer';
import DesignToolReducer from '@store/reducers/DesignToolReducer';
import TechPackReducer from '@store/reducers/TechPackReducer';
import SampleReducer from '@store/reducers/SampleReducer';
import LoaderReducer from '@store/reducers/LoaderReducer';
import favouriteReducer from '@store/favourite/reducers';
import filterReducer from '@store/filter/reducer';
import recostingReducer from '@store/recosting/reducers';
import SampleViewReducer from '@store/reducers/SampleViewReducer';
import BuyerRequestReducer from '@store/reducers/BuyerRequestReducer';
import MoodboardReducer from '@store/reducers/MoodboardReducer';
import ChatReducer from '@store/reducers/ChatReducer';
import ActivePageReducer from '@store/reducers/ActivePageReducer';
import TeamMembersReducer from '@store/reducers/TeamMembersReducer';
import AccountManagerReducer from '@store/reducers/AccountManagerReducer';
import ProjectManagerReducer from '@store/reducers/ProjectManagerReducer';
import MerchandiserReducer from '@store/reducers/MerchandiserReducer';
import StyleNumberReducer from '@store/reducers/StyleNumberReducer';
import PONumberReducer from '@store/reducers/PONumberReducer';
import CommercialReducer from '@store/reducers/CommercialReducer';
import SalesContractReducer from '@store/reducers/SalesContractReducer';
import FactoryReducer from '@store/reducers/FactoryReducer';
import OrderTitleReducer from '@store/reducers/OrderTitleReducer';
import OrderDashboardReducer from '@store/reducers/OrderDashboardReducer';
import SupplierReducer from '@store/reducers/SupplierReducer';
import CompositionReducer from '@store/reducers/CompositionReducer';
import BrandProfileReducer from '@store/reducers/BrandProfileReducer';
import SystemPreferenceReducer from '@store/reducers/SystemPreferenceReducer';
import CRMCommonReducer from '@store/reducers/crm/CRMCommonReducer';
import CRMConfigurationReducer from '@store/reducers/crm/CRMConfigurationReducer';
import BlockReducer from '@store/reducers/BlockReducer';
import MeasurementReducer from '@store/reducers/MeasurementReducer';
import DesignViewModalReducer from '@store/reducers/DesignViewModalReducer';
import BlockSuggestionsReducer from '@store/reducers/BlockSuggestionReducer';
import CostingReducer from '@store/reducers/CostingReducer';
import DesignToolCommentReducer from '@store/reducers/DesignToolCommentReducer';
import MyColleaguesReducer from '@store/reducers/MyColleaguesReducer';
import notificationReducer from '@store/reducers/NotificationReducer';
import PhotographyReducer from '@store/reducers/PhotographyReducer';
import productReducer from '@store/reducers/product';
import projectReducer from '@store/reducers/project';
import questionairreReducer from '@store/reducers/questionairre';
import rfqReducer from '@store/reducers/rfq';
import sidebarReducer from '@store/reducers/sidebar';
import OnboardingReducer from '@store/reducers/supplier-onboarding/OnboardingReducer';
import TrendResearchReducer from '@store/reducers/trend-research/TrendResearchReducer';
import CollectionSearchOptionsReducers from '@store/searchOptions/reducers';
import supplierReducer from '@store/supplier/reducer';
import baseApi from '@store/api/baseApi';
import surveySparrowReducer from '@store/surveySparrow/reducers';

const rootReducer = combineReducers({
	sidebar: sidebarReducer,
	questionairre: questionairreReducer,
	project: projectReducer,
	product: productReducer,
	rfq: rfqReducer,
	notification: notificationReducer,
	design: designReducer,
	filters: filterReducer,
	recosting: recostingReducer,
	supplier: supplierReducer,
	selectedItems: checkboxFilterReducer,
	materials: materialReducer,
	commonFilters: commonFiltersReducer,
	orders: orderReducer,
	salesContract: salesContractReducer,
	marketStore: MarketReducer,
	brandStore: BrandReducer,
	categoryStore: CategoryReducer,
	seasonStore: SeasonReducer,
	fabricStore: FabricReducer,
	materialStore: MaterialReducer,
	collectionStore: CollectionReducer,
	filterFieldStore: FilterFieldReducer,
	roleBasedCollectionStore: RoleBasedCollection,
	filterResponseStore: FilterResponseReducer,
	dependentFilterListStore: DependentFilterListReducer,
	slectedCheckBoxFieldStore: SlectedCheckBoxFieldReducer,
	userStore: UserReducer,
	commercialDashboard: commercialDashboardReducer,
	designToolStore: DesignToolReducer,
	designToolCommentStore: DesignToolCommentReducer,
	techPackStore: TechPackReducer,
	sampleStore: SampleReducer,
	loaderStore: LoaderReducer,
	favourite: favouriteReducer,
	sampleViewStore: SampleViewReducer,
	photographyStore: PhotographyReducer,
	costingStore: CostingReducer,
	buyerRequestStore: BuyerRequestReducer,
	moodboardStore: MoodboardReducer,
	chatReducer: ChatReducer,
	activePageReducer: ActivePageReducer,
	teamMembersReducer: TeamMembersReducer,
	acManagerStore: AccountManagerReducer,
	projectManagerStore: ProjectManagerReducer,
	merchandiserStore: MerchandiserReducer,
	orderStyleStore: StyleNumberReducer,
	orderPOStore: PONumberReducer,
	orderTitleStore: OrderTitleReducer,
	FactoryStore: FactoryReducer,
	SalesContractStore: SalesContractReducer,
	CommercialInvoiceStore: CommercialReducer,
	orderDashboardStore: OrderDashboardReducer,
	supplierStore: SupplierReducer,
	compositionStore: CompositionReducer,
	brandProfileStore: BrandProfileReducer,
	systemPreferenceReducer: SystemPreferenceReducer,
	crmCommonStore: CRMCommonReducer,
	crmConfigStore: CRMConfigurationReducer,
	blockStore: BlockReducer,
	measurementStore: MeasurementReducer,
	designViewModalStore: DesignViewModalReducer,
	multiLevelFIlterStore: MultiLevelFilterReducer,
	togleBlockSuggestionFilterStore: ToggleBlockSuggestionFilterReducer,
	blockSuggestionStore: BlockSuggestionsReducer,
	myColleaguesStore: MyColleaguesReducer,
	supplierOnboardingStore: OnboardingReducer,
	trendResearchStore: TrendResearchReducer,
	collectionSearchOptionStore: CollectionSearchOptionsReducers,
	scanStore: scanReducer,
	surveySparrowStore: surveySparrowReducer,
	favouritePageStore: favouriteSlice, // move all the favourite store here in the future development
	[baseApi.reducerPath]: baseApi.reducer,
	myProjectStore: myProjectSlice,
	myProjectDetailsStore: myProjectDetailsSlice,
	materialRequisitionStore: MaterialRequisitionReducer
});

export default rootReducer;

// design selectors
export const getAllCollections = (state) => state.design.allCollections;
export const getAllBrands = (state) => state.design.allBrands;
export const getAllMarkets = (state) => state.design.allMarkets;
export const getAllCategories = (state) => state.design.allCategories;
export const getAllSubCategories = (state) => state.design.allSubCategories;
export const getAllSeasons = (state) => state.design.allSeasons;
export const getAllFabricTypes = (state) => state.design.allFabricTypes;
export const getAllFabrics = (state) => state.design.allFabrics;
export const getAllFabricPatterns = (state) => state.design.allFabricPatterns;
export const getAllColors = (state) => state.design.allColors;
export const getAllGroupColors = (state) => state.design.allGroupColors;
export const getAllComposition = (state) => state.design.allComposition;
export const getDesignDetails = (state) => state.design.designDetails;
export const getDocumentResponse = (state) => state.design.documentResponse;
export const getProductMatrials = (state) => state.design.productMatrials;
export const getAllTrims = (state) => state.design.allTrims;
export const getTrimsType = (state) => state.design.trimTypes;
export const getPomAndSize = (state) => state.design.pomAndSize;
export const getAllTemplate = (state) => state.design.allTemplate;
export const getBrandingCategories = (state) => state.design.brandingCategories;
export const getBrandingTypes = (state) => state.design.brandingTypes;
export const getInitialCosting = (state) => state.design.initialCosting;
export const getQuantityWiseCosting = (state) => state.design.quantityWiseCosting;
export const getEnumFilter = (state) => state.design.enumFilter;
export const getEmbellishmentSubCategory = (state) => state.design.embellishmentSubCategory;
export const getLabelPackSubTypes = (state) => state.design.labelPackSubTypes;
export const getAvailableSizeForProduct = (state) => state.design.sizeForProducts;

// recosting selectors
export const getRequestedBy = (state) => state.recosting.requestedBy;
export const getAllCountries = (state) => state.supplier.allCountries;
export const getAllCities = (state) => state.supplier.allCities;
export const getAllTags = (state) => state.supplier.allTags;
export const getSuppliersDetails = (state) => state.supplier.suppliersDetails;
export const getSuppliersPhotoGallarey = (state) => state.supplier.suppliersPhotoGallarey;
export const getSuppliersCertificates = (state) => state.supplier.suppliersCertificates;
export const getSuppliersReviewSummaries = (state) => state.supplier.suppliersReviewSummaries;
export const getSuppliersReviews = (state) => state.supplier.suppliersReviews;
export const getAllSuppliersMaterials = (state) => state.supplier.allSuppliersMaterials;
export const getSuppliersMaterialList = (state) => state.supplier.supplierMaterialList;
export const getSupplier = (state) => state.supplier.supplier;
export const getAllSuppliersList = (state) => state.supplier.allSuppliersList;

// material reducer
export const getGarmentsDetails = (state) => state.materials.garmentsDetails;
export const getEmbellishmentDetails = (state) => state.materials.embellishmentDetails;
export const getTrimsDetails = (state) => state.materials.trimsDetails;
export const getBrandingDetails = (state) => state.materials.brandingDetails;
export const getWashingDetails = (state) => state.materials.washingDetails;
export const getMaterialsDetails = (state) => state.materials.fabricDetails;
export const getMaterialSuppliers = (state) => state.materials.materialSuppliers;
export const getPinnedMaterials = (state) => state.materials.pinnedMaterials;

//common filters
export const getCommonFilters = (state) => state.commonFilters.filters;

// order reducers
export const getDefaultQuotes = (state) => state.orders.defaultQuotes;
export const getInvoiceDetails = (state) => state.orders.invoiceDetails;
export const getBrandLocationList = (state) => state.orders.brandLocationList;
export const getBeneficiaryList = (state) => state.orders.beneficiaryList;
export const getNitexBankDetails = (state) => state.orders.nitexBankDetails;
export const getOrderPlaceWorkflow = (state) => state.orders.orderPlaceWorkFlow;
export const getOrderDetailsInfo = (state) => state.orders.orderDetailsInfo;
export const getAllUsersByTypes = (state) => state.orders.alllUsersByTypes;

// sales contract reducers
export const getSalesContractDetails = (state) => state.salesContract.salesContractDetails;

// commercial dashboard reducers
export const getSelectedBrand = (state) => state.commercialDashboard.selectedBrand;
export const getSelectedManager = (state) => state.commercialDashboard.selectedManager;
export const getOrderSearchValue = (state) => state.commercialDashboard.orderSearchValue;

// favourite reducer
export const getFavouriteProducts = (state) => state.favourite.favouriteProducts;
export const getFavouriteMaterials = (state) => state.favourite.favouriteMaterials;

// Notification reducer
export const getNotification = (state) => state.notification;

export const useMeasurement = () => useSelector((store) => store.measurementStore);
export const useDesignViewModal = () => useSelector((store) => store.designViewModalStore);

// Block Product List
export const useBlockProductList = () => useSelector((store) => store.blockSuggestionStore);

// My Colleagues reducer
export const useMyColleagues = () => useSelector((store) => store.myColleaguesStore);

// My Project reducer
export const useMyProject = () => useSelector((store) => store.myProjectStore);

// My Project Details reducer
export const useMyProjectDetails = () => useSelector((store) => store.myProjectDetailsStore);
